<footer class="footer position-relative">
  <div class="position-relative footer__child-wrap">
    <div class="discover">
      <div
        class="container d-flex flex-column align-items-center discover__container pb-5 pb-md-auto"
      >
        <!-- <h3 class="mb-0">
          Discover everything you can <span>achieve with us</span> today and
          beyond!
        </h3>
        <button class="btn btn-primary" (click)="onGetStartedClick()">
          Get Started
        </button> -->
        <app-suggest-idea></app-suggest-idea>
      </div>
    </div>
    <img
      width="100%"
      height="100%"
      fetchpriority="low"
      class="mb-5"
      imgLazyLoad="images/footer-bg.svg"
      alt="Footer"
    />
    <div class="container">
      <div class="row">
        <div
          class="col-md-3 d-none footer__col-first d-md-flex flex-column align-items-center align-items-md-start mb-4 mb-md-auto"
        >
          <div class="cursor-pointer" (click)="redirectToIndiaAI()">
            <img
              width="115"
              height="76"
              imgLazyLoad="images/india-ai-footer-logo.svg"
              src="images/india-ai-footer-logo.svg"
              alt="AIKosh"
              title="AIKosh"
            />
          </div>
          <p>Dataset Platform</p>
          <ul class="m-0 p-0">
            <li>Last Deployed : 02nd Nov, 26</li>
            <li>
              Visitors:
              <span class="visitor-no">{{ visitorCount | number }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-6 footer__col-mid mt-4">
          <div class="row">
            <div class="col-6 col-md-4 mb-5 mb-md-auto">
              <h4>AIKosh</h4>
              <ul class="m-0 p-0">
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.aboutUs]"
                  >
                    About us
                  </a>
                </li>
                  <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="[
                      '/',
                      routes.home,
                      routes.article,
                      routes.categoryListing,
                    ]"
                    >Articles</a
                  >
                </li>
                <!-- <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.termsNCondition]"
                  >
                    Terms of Use
                  </a>
                </li> -->
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.sitemap]"
                    >Sitemap</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-6 col-md-4 mb-5 mb-md-auto">
              <h4>Resources</h4>
              <ul class="m-0 p-0">
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="[
                      '/',
                      routes.home,
                      routes.datasets,
                      routes.all,
                    ]"
                    >Datasets</a
                  >
                </li>
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.models, routes.all]"
                    >Models</a
                  >
                </li>
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="[
                      '/',
                      routes.home,
                      routes.usecases,
                      routes.all,
                    ]"
                    >Use Cases</a
                  >
                </li>
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.toolkit]"
                    >Toolkits</a
                  >
                </li>
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.notebook]"
                    >Notebook</a
                  >
                </li>
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.competitions]"
                    >Competitions</a
                  >
                </li>
                <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="['/', routes.home, routes.resources]"
                    >Tutorials</a
                  >
                </li>
                <!-- <li>
                  <a
                    class="text-white text-decoration-none"
                    [routerLink]="[
                      '/',
                      routes.home,
                      routes.article,
                      routes.categoryListing,
                    ]"
                    >Articles</a
                  >
                </li> -->
              </ul>
            </div>
            <div class="col-6 col-md-4">
              <h4>Support</h4>
              <ul class="m-0 p-0">
                <li>
                  <a
                    [routerLink]="['/', routes.home, routes.faqs]"
                    class="text-white text-decoration-none"
                    >FAQs</a
                  >
                </li>
                <li>
                  <a
                    (click)="utilityService.onGrievanceClick($event)"
                    class="text-white text-decoration-none"
                  >
                    Grievances</a
                  >
                </li>

                <li>
                  <a
                    [routerLink]="['/', routes.home, routes.userManual]"
                    class="text-white text-decoration-none"
                  >
                    User Manual</a
                  >
                </li>

                <!-- <li>
                  <a
                    [routerLink]="['/', routes.home, routes.securityMeasures]"
                    class="text-white text-decoration-none"
                  >
                    Security Measures</a
                  >
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div
          class="col-md-3 footer__col-last mt-4 d-flex flex-row flex-md-column justify-content-between align-items-center align-items-md-end"
        >
          <div
            class="col-md-3 d-md-none footer__col-first d-flex flex-column align-items-start mb-4 mb-md-auto"
          >
            <div class="cursor-pointer" (click)="redirectToIndiaAI()">
              <img
                width="115"
                height="76"
                imgLazyLoad="images/india-ai-footer-logo.svg"
                src="images/india-ai-footer-logo.svg"
                alt="AIKosh"
                title="AIKosh"
              />
            </div>
            <p>Dataset Platform</p>
            <ul class="m-0 p-0">
              <li>Last Deployed :   02nd Nov, 26</li>
              <li>
                Visitors:
                <span class="visitor-no">{{ visitorCount | number }}</span>
              </li>
            </ul>
          </div>
          <ul class="m-0 p-0 d-flex align-items-center justify-content-center">
            <li>
              <a title="LinkedIn" [href]="socialLinks.linkedIn" target="_blank">
                <img
                  width="28"
                  height="28"
                  fetchpriority="low"
                  imgLazyLoad="images/linkedin.svg"
                  alt="LinkedIn"
                />
              </a>
            </li>
            <li>
              <a title="Facebook" [href]="socialLinks.facebook" target="_blank">
                <img
                  width="28"
                  height="28"
                  fetchpriority="low"
                  imgLazyLoad="images/facebook.svg"
                  alt="Facebook"
                />
              </a>
            </li>
            <li>
              <a title="Twitter" [href]="socialLinks.twitter" target="_blank">
                <img
                  width="28"
                  height="28"
                  fetchpriority="low"
                  imgLazyLoad="images/twitter-x.svg"
                  alt="Twitter"
                />
              </a>
            </li>
            <li>
              <a title="Youtube" [href]="socialLinks.youtube" target="_blank">
                <img
                  width="28"
                  height="28"
                  fetchpriority="low"
                  imgLazyLoad="images/youtube.svg"
                  alt="Youtube"
                />
              </a>
            </li>
          </ul>
          <!-- <div class="powered-by mt-4 d-none d-md-block">
            <span>Powered By</span>
            <img
              width="86"
              height="48"
              fetchpriority="low"
              imgLazyLoad="images/di.svg"
              alt="Digital India"
            />
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="copyright d-md-none">
    <div
      class="container d-flex align-items-center justify-content-center flex-column-reverse gap-3"
    >
      <p>
        © {{ currentYear }} - Copyright AIKosh. All rights reserved.
      </p>
      <ul class="d-flex align-items-center m-0 p-0 z-2">
        <li class="cursor-pointer">
          <a
            [routerLink]="['/', routes.home, routes.termsNCondition]"
            class="text-white text-decoration-none"
          >
            Terms of Use</a
          >
        </li>
        <li class="cursor-pointer">
          <a
            [routerLink]="['/', routes.home, routes.privacyPolicy]"
            class="text-white text-decoration-none"
          >
            Privacy Policy
          </a>
        </li>
      </ul>
    </div>
  </div>
  <!-- <div
    class="powered-by pb-5 d-md-none d-flex justify-content-center align-items-center"
  >
    <span>Powered By</span>
    <img
      width="86"
      height="48"
      fetchpriority="low"
      imgLazyLoad="images/di.svg"
      alt="Digital India"
    />
  </div> -->
</footer>
<div class="copyright d-none d-md-block">
  <div
    class="container d-flex align-items-center justify-content-center justify-content-md-between flex-column-reverse gap-3 gap-md-0 flex-md-row"
  >
    <p>
      © {{ currentYear }} - Copyright AIKosh. All rights reserved.
    </p>
    <ul class="d-flex align-items-center m-0 p-0 z-2">
      <li class="cursor-pointer mr-5px">
        <a
          [routerLink]="['/', routes.home, routes.termsNCondition]"
          class="text-white text-decoration-none"
        >
          Terms of Use</a
        >
      </li>
      <li class="cursor-pointer">
        <a
          [routerLink]="['/', routes.home, routes.privacyPolicy]"
          class="text-white text-decoration-none"
        >
          Privacy Policy
        </a>
      </li>
    </ul>
  </div>
</div>
